<template>
  <tg-dropdown
    :items="dates"
    @on-change="handleChange"
    trigger="click"
    :value="selected"
  ></tg-dropdown>
</template>

<script>
import TgDropdown from "@/components/dropdown/TgDropdown";
import { dateRangeMixins } from "./mixins";

export default {
  components: {
    TgDropdown,
  },
  mixins: [dateRangeMixins],
  data() {
    return {
      selected: {},
    };
  },
  created() {
    this.$nextTick(() => {
      this.handleChange(this.dates.find((x) => x.name === "today"));
    });
  },
  computed: {
    label() {
      return this.selected.label ? this.selected.label : "日期區間";
    },
  },
  methods: {
    handleChange(item) {
      this.selected = item;
      this.$emit("on-change", item.value);
    },
    unset() {
      this.selected = {};
    },
    select(name) {
      let selected = this.dates.find((x) => x.name == name);

      if (selected) {
        this.selected = selected;
        this.$emit("on-change", selected.value);
      }
    },
  },
  watch: {
    dates(val) {
      let item = val.find((x) => x.active == true);
      if (!item) {
        item = val.find((x) => x.name == "today");
      }
      this.handleChange(item);
    },
    value(val) {
      if (typeof val === "object") {
        this.selected = val;
      } else {
        let filter = this.items.filter((x) => x.name == val);
        if (filter.length) {
          this.selected = this.items.filter((x) => x.name == val)[0];
        }
      }
    },
  },
};
</script>
